module.exports = __webpack_public_path__ + "static/media/money_market_aggresive.24098694.svg";